import React, { Component } from "react";
import { Row, Col, CardHeader, CardFooter, Card, Button } from "reactstrap";
import CountUp from "react-countup";
import BlockUi from "react-block-ui";
import { Loader } from "react-loaders";
import { IoEyeOutline } from "react-icons/io5";

class OnStation extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  toggle = () => {
    // Populate list on Parent:
    this.props.showOnStation();
  };

  render() {
    const { data } = this.props;
    const total = data && data.total ? data.total : 0;

    return (
      <BlockUi
        tag="div"
        blocking={this.props.blocking}
        loader={<Loader active type={this.props.loaderType} />}
      >
        <Card className="mb-3">
          <CardHeader className="card-header-tab">
            <div className="card-header-title">
              <i className="header-icon lnr-inbox"> </i>
              On Station
            </div>
          </CardHeader>
          <Row className="no-gutters">
            <Col sm="12" md="12" xl="12">
              <div
                className="card no-shadow rm-border bg-transparent widget-chart text-center"
                style={{ padding: "11px 16px" }}
              >
                <div className="widget-chart-content">
                  <div className="widget-numbers">
                    <CountUp
                      start={0}
                      end={total}
                      separator=" "
                      decimals={0}
                      decimal="."
                      prefix=""
                      useEasing={true}
                      suffix=""
                      duration="2"
                    />
                    <small className="widget-subheading">
                      <b>{this.props.title}</b>
                    </small>
                  </div>
                </div>
              </div>
              <div className="divider m-0 d-md-none d-sm-block" />
            </Col>
          </Row>
          <CardFooter className="text-center d-block p-3">
            <Button
              color="info"
              className="btn-pill btn-shadow btn-wide "
              size="md"
              onClick={this.toggle}
            >
              <span className="mr-2 opacity-7">
                <IoEyeOutline fontSize="23px" color="#ffffff"/>
              </span>
              <span className="mr-1">Show</span>
            </Button>
          </CardFooter>
        </Card>
      </BlockUi>
    );
  }
}

export default OnStation;



// WEBPACK FOOTER //
// ./src/Stations/OnStations.jsx